// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 174 ? "46c7693c" : chunkId) + "." + {"174":"e097839d6a0272ca","376":"7c835da45d4abfd9"}[chunkId] + ".js";
};